import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isUserInfoOpen", "setOpenUserInfo", "searchProps", "navigation", "mobileSubMenu", "setMobileSubMenu"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useCallback, useMemo, useState } from 'react';
import { defaultTexts } from './constants';
import { searchInNavigation } from './utils';
export function useHeader(_ref) {
  var _searchProps$results, _mobileSubMenu$, _mobileSubMenu$$items;

  var isUserInfoOpen = _ref.isUserInfoOpen,
      setOpenUserInfo = _ref.setOpenUserInfo,
      searchProps = _ref.searchProps,
      _ref$navigation = _ref.navigation,
      navigation = _ref$navigation === void 0 ? [] : _ref$navigation,
      mobileSubMenuProps = _ref.mobileSubMenu,
      setMobileSubMenu = _ref.setMobileSubMenu,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openUserInfo = _useState2[0],
      setIsUserInfoOpen = _useState2[1];
  /**
   * Поиск
   */


  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchValue = _useState4[0],
      setSearchValue = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSearch = _useState6[0],
      setIsSearch = _useState6[1];

  var handleChangeSearch = useCallback(function (value) {
    setSearchValue(value);

    if (searchProps !== null && searchProps !== void 0 && searchProps.onChange) {
      searchProps.onChange(value);
    }
  }, [searchProps]);
  var handleOpenSearch = useCallback(function () {
    setIsSearch(true);
  }, []);
  var handleCloseSearch = useCallback(function () {
    setIsSearch(false);
  }, []);
  var handleToggleSearch = useCallback(function () {
    return setIsSearch(function (prev) {
      return !prev;
    });
  }, []);
  var mobileNavigation = useMemo(function () {
    return navigation.map(function (section) {
      if (!section.items) {
        return section;
      }

      var items = [];
      section.items.forEach(function (item) {
        if (Array.isArray(item)) {
          items.push.apply(items, _toConsumableArray(item));
          return;
        }

        items.push(item);
      });
      return _objectSpread(_objectSpread({}, section), {}, {
        items: items
      });
    });
  }, [navigation]); // Используется для результатов поиска на мобилке и на десктопе,
  // А также для меню навигации на мобилке от сюда и тип: Navigation<NavigationItemShape>[] | NavigationItemShape[]

  var navigationResult = useMemo(function () {
    return searchValue ? searchInNavigation(searchValue, mobileNavigation) : mobileNavigation;
  }, [mobileNavigation, searchValue]);
  var searchNotFound = navigationResult.length === 0 && (!(searchProps !== null && searchProps !== void 0 && searchProps.results) || (searchProps === null || searchProps === void 0 ? void 0 : (_searchProps$results = searchProps.results) === null || _searchProps$results === void 0 ? void 0 : _searchProps$results.length) === 0) && !(searchProps !== null && searchProps !== void 0 && searchProps.loading);
  /**
   * Мобильное меню
   */

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      mobileSubMenuDefault = _useState8[0],
      setMobileSubMenuDefault = _useState8[1];

  var mobileSubMenu = mobileSubMenuProps || mobileSubMenuDefault;
  var mobileSelectedGroup = mobileSubMenu && navigationResult && !searchValue ? (_mobileSubMenu$ = navigationResult[mobileSubMenu[0]]) === null || _mobileSubMenu$ === void 0 ? void 0 : (_mobileSubMenu$$items = _mobileSubMenu$.items) === null || _mobileSubMenu$$items === void 0 ? void 0 : _mobileSubMenu$$items[mobileSubMenu[1]] : undefined;
  return _objectSpread(_objectSpread({}, props), {}, {
    navigation: navigation,
    isUserInfoOpen: isUserInfoOpen !== null && isUserInfoOpen !== void 0 ? isUserInfoOpen : openUserInfo,
    setIsUserInfoOpen: setOpenUserInfo !== null && setOpenUserInfo !== void 0 ? setOpenUserInfo : setIsUserInfoOpen,
    searchValue: searchValue,
    isSearch: isSearch,
    handleOpenSearch: handleOpenSearch,
    handleCloseSearch: handleCloseSearch,
    handleChangeSearch: handleChangeSearch,
    handleToggleSearch: handleToggleSearch,
    searchProps: searchProps,
    searchLoading: searchProps === null || searchProps === void 0 ? void 0 : searchProps.loading,
    searchPlaceholder: (searchProps === null || searchProps === void 0 ? void 0 : searchProps.placeholder) || defaultTexts.mobileSearchPlaceholder,
    searchNotFoundTitle: defaultTexts.notFoundTitle || undefined,
    searchNotFoundSubtitle: (searchProps === null || searchProps === void 0 ? void 0 : searchProps.notFoundSubtitle) || defaultTexts.notFoundSubtitle,
    navigationResult: navigationResult,
    searchNotFound: searchNotFound,
    searchResults: searchProps === null || searchProps === void 0 ? void 0 : searchProps.results,
    mobileSelectedGroup: mobileSelectedGroup,
    setMobileSubMenu: setMobileSubMenu || setMobileSubMenuDefault,
    mobileSubMenu: mobileSubMenu
  });
}